/**
 * EN → KR 번역 사전.
 * useT()가 KR 모드에서 이 사전을 조회한다. 없는 키는 영어 그대로 표시.
 * 새 문자열은 여기에 추가하면 된다.
 */
export const DICTIONARY = {
  /* ── GNB 메뉴 ── */
  Home: '홈',
  Career: '커리어',
  'Job Board': '채용 공고',
  Workshop: '워크숍',
  Pathfinder: '패스파인더',
  Article: '아티클',
  Skills: '교육•스킬',
  'Course sites for Korean careers': '한국 커리어를 위한 강의 사이트',

  /* ── GNB 드롭다운 ── */
  Resume: '이력서',
  'Start Resume': '이력서 시작하기',
  'Resume Builder': '이력서 빌더',
  'Manage Resume': '이력서 관리',
  'Resume Guide': '이력서 가이드',
  Community: '커뮤니티',
  'Q&A': 'Q&A',
  'No Korean? No Problem.': '한국어를 몰라도 괜찮아요.',
  'Learn what employers expect and how to structure your K-resume.':
    '기업이 기대하는 것과 K-이력서 작성법을 알아보세요.',
  'My Apply': '지원 현황',
  'Job Postings': '채용 공고 관리',
  Applicants: '지원자',
  'Business Development Manager, Full-time': '사업개발 매니저 · 정규직',
  Keyword: '키워드',
  Culture: '문화',
  etc: '기타',
  'Cultural Explorer': '문화 탐험가',
  'Career Builder': '커리어 빌더',
  'Koready Navigator': '코레디 내비게이터',
  'Network Connector': '네트워크 커넥터',
  'Be Koready': 'Be Koready',
  Start: '시작하기',
  Dashboard: '대시보드',
  Diagnostic: '진단',
  Active: '진행 중',
  'Begin your Korean career journey with Pathfinder.':
    '패스파인더와 함께 한국 커리어 여정을 시작하세요.',
  'Gyeongbokgung Palace Hanbok Photoshoot & Tour': '경복궁 한복 촬영 & 투어',

  /* ── GNB 우측 / 계정 메뉴 ── */
  Login: '로그인',
  'Log out': '로그아웃',
  Profile: '프로필',
  Jobs: '채용',
  'Account settings': '계정 설정',
  'My Dashboard': '내 대시보드',
  'My Profile': '내 프로필',
  Activities: '활동 내역',
  Settings: '설정',
  'Become a Creator': '크리에이터 시작하기',

  /* ── 푸터 ── */
  'empowers global talents to build sustainable careers in Korea.':
    '글로벌 인재가 한국에서 지속가능한 커리어를 만들도록 돕습니다.',
  'contact us': '문의하기',
  'About us': '회사 소개',
  'What we do': '우리가 하는 일',
  'Join our team': '팀 합류하기',
  FAQ: '자주 묻는 질문',
  Programs: '프로그램',
  Services: '서비스',
  Social: '소셜',
  /* ── 홈: PathfinderHero ── */
  'For User': '유저용',
  'For Business': '기업용',
  'For Creator': '크리에이터용',
  'Get started': '시작하기',

  /* ── 홈: Free Booster Lectures ── */
  'Free Booster Lectures': '무료 부스터 강의',
  'Free Lectures below': '아래에서 무료 강의를 만나보세요',
  Free: '무료',
  'Quick add': '빠른 신청',

  /* ── 홈: Sustainable Career ── */
  'Build a Sustainable': '한국에서 지속가능한',
  'Career & Life in Korea': '커리어와 삶을 만드세요',
  'Build a Sustainable Career & Life in Korea':
    '한국에서 지속가능한 커리어와 삶을 만드세요',
  'Know Where You Are': '현재 위치를 파악하세요',
  'Move Forward': '앞으로 나아가세요',
  'Everything You Need to Apply': '지원에 필요한 모든 것',
  'Your Life in Korea': '한국에서의 삶',
  'Diagnose your current readiness for Korea through Pathfinder.':
    '패스파인더로 한국 진출 준비도를 진단해 보세요.',
  'Koready supports adaption and long-term life planning in Korea.':
    'Koready가 한국 적응과 장기적인 라이프 플랜을 지원합니다.',
  'O!ng Lab supports adaption and long-term life planning in Korea.':
    'O!ng Lab이 한국 적응과 장기적인 라이프 플랜을 지원합니다.',
  'Get now': '지금 시작하기',

  /* ── 홈: Be a Creator ── */
  'The ultimate platform for Korea experts.':
    '한국 전문가를 위한 최고의 플랫폼.',
  'Teach, guide, and earn by sharing everything you know about Korea.':
    '한국에 대해 아는 모든 것을 나누며 가르치고, 안내하고, 수익을 얻으세요.',
  'Contact Us': '문의하기',
  'We have the canvas.': '캔버스는 저희가 준비했어요.',
  'Start free': '무료로 시작하기',

  'Terms,': '이용약관,',
  PrivacyPolicy: '개인정보처리방침',
};
